<template>
  <div class="content-container flex-column">

    <!-- Toolbar Profile -->
    <div class="grid-x toolbar fixed responsive">
      <div class="cell auto toolbar-responsive small-order-2 xxlarge-order-1">
        <div class="tabs large">
          <ul>
            <li v-for="(tabItem, key) in tabs" :key="key" :class="{'active' : key === selectedTab}">
              <a href="javascript:;" @click="tab(key)">{{ tabItem.name }}</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="cell shrink toolbar-responsive small-order-1 xxlarge-order-2">
        <div class="cell auto hide-for-xxlarge">
          <a href="javascript:;" @click="showProfileSidebar()" class="button action toggle-sidebar-button profile">
            <span class="avatar icon profile">
              <svg width="32px" height="32px" viewBox="0 0 80 80"><use xlink:href="/static/sprites.svg#user-avatar-glyph-large"></use></svg>
            </span>
            <span class="button-info">
              <span class="profile-user-name">{{kunde.full_name}}</span>
              <span class="profile-user-title">Kundenr: {{kunde.Kundenr}}</span>
            </span>
            <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-select"></use></svg></span>
          </a>
        </div>
        <template v-if="selectedTab === 'objektSeller'">
          <a v-if="exportState !== 'exporting'" @click="onExportClick('export-innlev-excel')" href="javascript:;" class="button action glyph glyph-only">
            <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-spreadsheet"></use></svg>
            <span class="loader-spinner"></span>
            <span>Export</span>
          </a>
          <a v-else-if="exportState === 'exporting'" href="javascript:;" class="button action glyph glyph-only loading">
            <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-spreadsheet"></use></svg>
            <span class="loader-spinner"></span>
            <span>Export</span>
          </a>
        </template>
        <template v-if="selectedTab === 'objekt'">
          <a v-if="exportState !== 'exporting'" @click="onExportClick('export-bought-excel')" href="javascript:;" class="button action glyph glyph-only">
            <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-spreadsheet"></use></svg>
            <span class="loader-spinner"></span>
            <span>Export</span>
          </a>
          <a v-else-if="exportState === 'exporting'" href="javascript:;" class="button action glyph glyph-only loading">
            <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-spreadsheet"></use></svg>
            <span class="loader-spinner"></span>
            <span>Export</span>
          </a>
        </template>
        <a href="javascript:;" @click="$emit('switchEOFakturaView', true)" class="button action glyph glyph-only-small">
          <span>EO-Faktura</span>
        </a>
        <a href="javascript:;" @click="$emit('switchKundeView', true)" class="button action glyph glyph-only-small">
          <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-edit"></use></svg>
          <span>Innstillinger</span>
        </a>
      </div>
    </div>

    <!-- Content -->
    <component v-bind:is="selectedTabComponent" v-bind="{kunde: kunde}"></component>
  </div>
</template>

<script>
import KundeCardShowTabKontrakt from './KundeCardShowTabKontrakt'
import KundeCardShowTabObjekt from './KundeCardShowTabObjekt'
import KundeCardShowTabObjektSeller from './KundeCardShowTabObjektSeller'
import KundeCardShowTabFullmakt from './KundeCardShowTabFullmakt'
import KundeCardShowTabAbonnement from './KundeCardShowTabAbonnement'
import KundeCardShowTabFaktura from './KundeCardShowTabFaktura'
import KundeCardShowTabInvoiceObjekt from './KundeCardShowTabInvoiceObjekt'
import KundeCardShowTabObjektUtlev from './KundeCardShowTabObjektUtlev'
import KundeCardShowTabUtleveringssedler from './KundeCardShowTabUtleveringssedler'

import bus from '@/plugins/event-bus'

export default {
  name: 'KundeCardShow',
  props: {
    kunde: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: true,
      exportState: 'submittable',
      tabs: {
        'kontrakt': {name: 'Kontrakter', component: KundeCardShowTabKontrakt},
        'objekt': {name: 'Kjøpte objekter', component: KundeCardShowTabObjekt},
        'objektSeller': {name: 'Innleverte objekter', component: KundeCardShowTabObjektSeller},
        'invoiceObjekt': {name: 'Fakturer objekter', component: KundeCardShowTabInvoiceObjekt},
        'fullmakt': {name: 'Fullmakt', component: KundeCardShowTabFullmakt},
        'abonnement': {name: 'Abonnement', component: KundeCardShowTabAbonnement},
        'faktura': {name: 'Faktura', component: KundeCardShowTabFaktura},
        'utelvering': {name: 'Objekter til utlevering', component: KundeCardShowTabObjektUtlev},
        'utelveringssedler': {name: 'Utelveringssedler', component: KundeCardShowTabUtleveringssedler}
      },
      selectedTab: 'kontrakt',
      selectedTabComponent: KundeCardShowTabKontrakt
    }
  },
  beforeDestroy () {
    window.jQuery('body').removeClass('show-sidebar-xxlarge')
  },
  created () {
    window.jQuery('body').addClass('show-sidebar-xxlarge')
    bus.$off('onExportExcel')
  },
  mounted: function () {
    let tab = 'kontrakt' // localStorage.kcm_tab || 'kontrakt'
    bus.$on('ar-invoiced', (data) => this.tab('faktura'))
    bus.$on('multi-faktura-invoiced', (data) => this.tab('invoiceObbjekt'))

    bus.$on('onExportExcel', (status) => this.onExportExcel(status))

    this.$store.dispatch('kundekontrakt/load', this.kunde.Kundenr)
    this.$store.dispatch('kundeobjektbuyerinvoice/load', this.kunde.Kundenr)
    this.$store.dispatch('kundeobjektbuyer/load', this.kunde.Kundenr)
    this.$store.dispatch('kundeobjektseller/load', this.kunde.Kundenr)
    this.$store.dispatch('kundefullmakt/load', this.kunde.Kundenr)
    this.$store.dispatch('kundebilag/load', this.kunde.Kundenr)
    this.$store.dispatch('kundeobjektdeliver/load', this.kunde.Kundenr)
    this.$store.dispatch('kundeobjektsignature/load', this.kunde.Kundenr)

    const skt = sessionStorage.showKundeTab || 'kontrakt'
    if (this.tabs.hasOwnProperty(skt)) {
      tab = skt

      sessionStorage.showKundeTab = null
    }
    this.tab(tab)
  },
  methods: {
    tab: function (tab) {
      if (this.tabs.hasOwnProperty(tab)) {
        // Save to localstorage - to remember
        // localStorage.kcm_tab = tab

        this.selectedTab = tab
        this.selectedTabComponent = this.tabs[tab].component
      }
    },
    showProfileSidebar: function () {
      this.$helpers.toggleSidebar('profile')
    },
    onExportClick: function (eventName) {
      bus.$emit(eventName)
    },
    onExportExcel: function (status) {
      this.exportState = status
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeCardShow.vue